export default __webpack_public_path__ + "static/media/icon-menu.f6fa37d1.svg";